import type { PageMeta } from '../types/content';

export const pageMeta = {
  home: {
    path: '/',
    title: 'Liftoff Investments | Civil Engineering & Construction Botswana',
    description:
      'Liftoff Investments (Pty) Ltd is a Botswana-owned construction and civil engineering company delivering roadworks, infrastructure, water and waste management, and building services.',
  },
  companyBackground: {
    path: '/about/company-background',
    title: 'Company Background | Liftoff Investments, Construction Company Gaborone',
    description:
      'Liftoff Investments (Pty) Ltd is a citizen-owned construction company based in Gaborone, incorporated in Botswana in May 2007, delivering roadworks, civil, water and building works.',
  },
  team: {
    path: '/about/management-team',
    title: 'Management & Technical Team | Liftoff Investments',
    description:
      'The management and technical team at Liftoff Investments: civil engineers, project managers, site managers and support staff based in Botswana.',
  },
  quality: {
    path: '/about/quality-project-management',
    title: 'Quality Assurance & Project Management | Liftoff Investments',
    description:
      'How Liftoff Investments plans, supervises, inspects and records construction work on roadworks, civil, water and building projects in Botswana.',
  },
  registrations: {
    path: '/about/registrations-procurement',
    title: 'Registrations & Procurement | Liftoff Investments',
    description:
      'Company registration details and PPADB procurement codes and grades for Liftoff Investments (Pty) Ltd, a Botswana construction and civil engineering contractor.',
  },
  services: {
    path: '/services',
    title: 'Construction & Civil Engineering Services Botswana | Liftoff Investments',
    description:
      'Road construction and maintenance, civil works, water and sanitation, stormwater drainage and culverts, building and structural works, and paving in Botswana.',
  },
  projects: {
    path: '/projects',
    title: 'Projects | Road, Water & Building Construction in Botswana | Liftoff Investments',
    description:
      'Documented roadworks, water and sanitation, sewer, mining earthworks and building projects by Liftoff Investments across Botswana.',
  },
  equipment: {
    path: '/plant-equipment',
    title: 'Construction Plant & Equipment Botswana | Liftoff Investments',
    description:
      'Graders, excavator, vibro roller, backhoe loaders, water bowsers, trucks and construction equipment listed in the Liftoff Investments plant schedule.',
  },
  contact: {
    path: '/contact',
    title: 'Contact & Request a Quote | Liftoff Investments, Gaborone',
    description:
      'Contact Liftoff Investments in Gaborone to discuss roadworks, civil engineering, water and sanitation or building projects in Botswana.',
  },
  privacy: {
    path: '/privacy-policy',
    title: 'Privacy Policy | Liftoff Investments',
    description:
      'How Liftoff Investments handles personal information submitted through the website enquiry form.',
  },
  notFound: {
    path: '/404',
    title: 'Page Not Found | Liftoff Investments',
    description: 'The page you were looking for could not be found.',
    noIndex: true,
  },
} satisfies Record<string, PageMeta>;

/** Public routes — use this list to generate sitemap.xml at the hosting root. */
export const sitemapPaths = Object.values(pageMeta)
  .filter((meta: PageMeta) => !meta.noIndex)
  .map((meta) => meta.path);
